import { render, staticRenderFns } from "./commentAside.vue?vue&type=template&id=569324fe&scoped=true"
import script from "./commentAside.vue?vue&type=script&lang=js"
export * from "./commentAside.vue?vue&type=script&lang=js"
import style0 from "./commentAside.vue?vue&type=style&index=0&id=569324fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569324fe",
  null
  
)

export default component.exports